import {routerMiddleware} from "connected-react-router";
import {applyMiddleware, compose, createStore} from "redux";
import reduxThunk from "redux-thunk";

import reducers from "../../reducers";
import history from "./history";

export default function configureStore() {
  const composeEnhacers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(
    reducers(history),
    composeEnhacers(applyMiddleware(reduxThunk, routerMiddleware(history)))
  );
}
